import { FC } from 'react';
import type { AuditToolSummaryRow } from './types';
import { formatMs } from './formatters';
import style from './audit-log.module.scss';

export const ToolSummaryTable: FC<{ rows: AuditToolSummaryRow[] }> = ({
  rows,
}) => {
  if (rows.length === 0) return <p className={style.muted}>No tool calls.</p>;
  return (
    <table className={style.innerTable}>
      <thead>
        <tr>
          <th>Tool</th>
          <th>Calls</th>
          <th>Pass</th>
          <th>Fail</th>
          <th>Avg</th>
          <th>Total</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((t) => {
          const avgMs =
            t.callCount > 0 ? Math.round(t.totalDurationMs / t.callCount) : 0;
          return (
            <tr key={t.toolName}>
              <td>{t.toolName}</td>
              <td>{t.callCount}</td>
              <td>{t.successCount}</td>
              <td>{t.failureCount}</td>
              <td>{formatMs(avgMs)}</td>
              <td>{formatMs(t.totalDurationMs)}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};
